import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FilterConstant } from '../constant/filterConstant';

@Injectable({
  providedIn: 'root',
})
export class ProjectFilterStoreService {

  constructor(
    private route: Router,
  ) { }

  /**
   * Method to determine if a filter should be shown based on the current URL.
   * @param filterName The name of the filter to check.
   * @returns boolean indicating whether the filter should be shown.
   */
  shouldShowFilter(filterName: string): boolean {
    const url = this.route.url;

    if (url.includes('/upload-candidates') || url.includes('/inbound-applications')) {
      return FilterConstant.PROJECT_UPLOAD_CANDIDATE_APPLICABLE_FILTER_MODEL.has(filterName);
    }

    if (url.includes('/search') || url.includes('/candidate-list')) {
      return FilterConstant.PROJECT_SEARCH_CANDIDATE_APPLICABLE_FILTER_MODEL.has(filterName);
    }

    return false;
  }

}
